import axios from 'axios';
import config from '../config';

export const attachOnboardDeviceOrganization = (deviceId: string, organizationId: string) => {
    return axios
        .put(`${config.API_URL}/onboard-devices/${deviceId}/organization`, { organizationId })
        .then((response: any) => {
            return response.data.message;
        });
};
